import React from "react";
import Paginator from "../shared/paginator.jsx";
import moment from "moment";
import context from "../../lib/context.js";
import { browserHistory } from "react-router";
import ajax from "./../../lib/ajax.js";

export default class ApplicantList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            resources: {}
        }

        this.onHeaderClick = this.onHeaderClick.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.loadResources = this.loadResources.bind(this);
    }

    componentDidMount() {
        this.loadResources();
    }

    loadResources() {
        const self = this;

        ajax.vm()
            .get(`applicant-list-resources`)
            .then(function (res) {
                self.setState({ resources: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("unauthorize") > -1) {
                    browserHistory.push(context.routeUrl(`home`));
                }
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    onHeaderClick(event) {
        if (this.props.onSort) {
            var sortExpression = event.target.getAttribute('type');

            if (this.props.search.sortExpression.indexOf(sortExpression) > -1) {
                if (this.props.search.sortExpression.indexOf(' desc') < 0)
                    sortExpression = sortExpression + ' desc';
            }

            this.props.onSort(sortExpression);
        }
    }

    onRowClick(event) {
        if (event.target.tagName.toUpperCase() == 'TR') {
            var ids = event.target.getAttribute("name").split('_');
            browserHistory.push(context.routeUrl(`${this.props.role}/applicant-entry/${ids[0]}/${ids[1]}`));
        }
        else if (event.target.tagName.toUpperCase() == 'TD') {
            var ids = event.target.parentElement.getAttribute("name").split('_');
            browserHistory.push(context.routeUrl(`${this.props.role}/applicant-entry/${ids[0]}/${ids[1]}`));
        }
    }

    render() {
        let items = [];

        let vm = this.props.vm; // Expected to be an array of listItem
        let totalPage = vm.total / vm.pageSize + 
            (vm.total % vm.pageSize > 0 ? 1 : 0); 

        if (vm == null || vm.applicants == null || vm.applicants == 0) {
            return(
                <div className="ap-fullsize ap-grid-result text-center">
                    {this.state.resources.noApplicantFound}
                </div>
                );
        } else {
            for(let i=0; i < vm.applicants.length; i++) {
                let applicant = vm.applicants[i]; // check first if result came from Legacy API

                items.push(
                    <tr name={applicant.requestID + '_' + applicant.applicantID} onClick={this.onRowClick} className="ap-clickable" >
                        <td>{moment(applicant.interviewDate).format("MM/DD/YYYY")}</td>
                        <td>{moment(applicant.resumeRecordedDate).format("MM/DD/YYYY")}</td>
                        <td>{applicant.internetApplicant == true ? 'Yes' : 'No'}</td>
                        <td>{applicant.specificSourceDescription}</td>
                        <td>{moment(applicant.searchDate).format("MM/DD/YYYY")}</td>
                        <td>{applicant.fullName}</td>
                        <td>{(applicant.sex == '' || applicant.sex == null) == false ? 'Recorded' : "Unrecorded" }</td>
                        <td>{(applicant.ethnicity == '' || applicant.ethnicity == null) == false  ? 'Recorded' : "Unrecorded" }</td>
                        <td>{applicant.disability != null ? 'Recorded' : "Unrecorded" }</td>
                        <td>{applicant.veteran != null ? 'Recorded' : "Unrecorded" }</td>
                        <td>{applicant.hired == true ? 'Yes' : 'No'}</td>
                        <td>{applicant.hiredNotes}</td>
                    </tr>);        
            }
        }

        return(
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <td><a href="#" onClick={this.onHeaderClick} type="InterviewDate">{this.state.resources.interviewDateHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="ResumeRecordedDate">{this.state.resources.dateResumeReceivedHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="InternetApplicant">{this.state.resources.internetApplicantHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="C.CodeName">{this.state.resources.specificSourceHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="SearchDate">{this.state.resources.searchDateHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="FullName">{this.state.resources.nameHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="Sex">{this.state.resources.genderHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="Ethnicity">{this.state.resources.ethnicityHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="Disability">{this.state.resources.disabilityHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="Veteran">{this.state.resources.veteranStatusHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="Hired">{this.state.resources.hiredHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="HiredNotes">{this.state.resources.hiredNotesHeader}</a></td>
                                </tr>
                            </thead>
                            <tbody>
                                {items}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Paginator total={totalPage} range="3" selectedIndex={vm.page} 
                            onNavigate={this.props.onNavigate}  />
                    </div>
                </div>
            </div>
        );
    }
}